import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';

const Skeleton = () => {
  return <div className="bg-surface-200-bg h-[297px] skeleton rounded-500"></div>;
};

const DynamicSwiperBanner = dynamic(() => import('./swiper-banner'), {
  ssr: false,
  loading: Skeleton
});

const SwiperBanner = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicSwiperBanner skeleton={skeleton} {...props} />;
};

export default SwiperBanner;
